import React from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getCreditsRemaining } from '../../utils/selectors';

const ContainerSmall = styled.div`
  height: 16px;
  border-radius: 10px;
  padding: 0px 4px;
  margin-right: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${props => props.theme.colors.lavender};
`;

const CreditCountSmall = styled.div`
  margin-left: 2px;
  font-size: 10px;
  line-height: 14px;
  color: ${props => props.theme.colors.black};
`;

export const MemberCreditsBadgeSmall = () => {
  const availableMemberCredits = useSelector(getCreditsRemaining);

  if (availableMemberCredits === 0) {
    return null;
  }
  return (
    <ContainerSmall>
      <img
        alt="Wheel"
        src="/static/images/wheel-logo.svg"
        width="10"
        height="10"
      />
      <CreditCountSmall>{availableMemberCredits}</CreditCountSmall>
    </ContainerSmall>
  );
};

const ContainerLarge = styled.div`
  height: 22px;
  border-radius: 10px;
  padding: 0px 6px;
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${props => props.theme.colors.lavender};
`;

const CreditCountLarge = styled.div`
  margin-left: 4px;
  font-size: 12px;
  line-height: 14px;
  color: ${props => props.theme.colors.black};
`;
export const MemberCreditsBadgeLarge = () => {
  const availableMemberCredits = useSelector(getCreditsRemaining);

  if (availableMemberCredits === 0) {
    return null;
  }
  return (
    <ContainerLarge>
      <img
        alt="Wheel"
        src="/static/images/wheel-logo.svg"
        width="16"
        height="16"
      />
      <CreditCountLarge>{availableMemberCredits}</CreditCountLarge>
    </ContainerLarge>
  );
};
